module.exports = __webpack_public_path__ + "static/media/proposition-car.e2fe6f04.jpg";